import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { WsService } from './ws/ws.service';

/**
 * A service that must be run when someone logs in
 * by card or by keypad.
 */
@Injectable()
export class BootstrapSessionService {
     constructor(private data: DataService, private ws: WsService) {}

     run() {
          this.ws.planning
               .userBookingList()
               .then((data) => {
                    this.data.userBooking$ = data as any;
               })
               .catch(() => {
                    // this.toastrService.error(window.appLang.GENERIC_ERROR_MSG);
               });
     }
}
